module.exports = __webpack_public_path__ + "img/flag-US.d9ab38fe.svg";